module.exports = __webpack_public_path__ + "img/State=3.895cab9d.svg";